import React, { useEffect, useState, useContext } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import {
  campaignFetcher,
  channelFetcher,
  videoFetcher,
} from "../../api/requests";
import { useToaster } from "../../context/toaster";
import { useParams } from "react-router-dom";
import { CategoryContext } from "../../context/categories";
import { TagsContext } from "../../context/tag";
import { useHistory } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { baseURL } from "../../api/dataFetcher";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../context/auth";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { ChannelContext } from "../../context/channels";

const ChannelEdit = () => {
  const [video, setVideo] = useState();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    cover: null,
    videoFile: null,
    cast: "",
    categorys: null,
    sub_categorys: null,
    tags: [],
    channel: null,
    published_date: "",
  });
  const [previewCover, setPreviewCover] = useState(null);
  // اگر کاربر تگ‌ها را تغییر دهد، تگ‌های قبلی ویدیو کنار گذاشته می‌شوند و فقط
  // انتخاب‌های تازه‌ی او ارسال می‌شود؛ اگر اصلاً به تگ‌ها دست نزند، همان
  // تگ‌های قبلی بدون تغییر باقی می‌مانند.
  const [tagsTouched, setTagsTouched] = useState(false);
  const { addMessage } = useToaster();
  const { id } = useParams();
  const { categories, subCategories } = useContext(CategoryContext);
  const { tags } = useContext(TagsContext);
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const repost = new URLSearchParams(location.search).get("repost");
  const [date, setDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa })
  );

  useEffect(() => {
    const getVideo = async () => {
      try {
        const videoData = await (campaignId
          ? campaignFetcher.getEachVideo(id)
          : videoFetcher.getEachVideo(id));
        setVideo(videoData);
      } catch (err) {
        setError("خطا در نمایش جزئیات ویدئو");
        console.error(err);
      }
    };

    getVideo();
  }, [id]);

  useEffect(() => {
    if (video) {
      setFormData({
        title: video.title || "",
        description: video.description || "",
        cover: null,
        videoFile: null,
        cast: video.cast || "",
        categorys: video.categorys?.id,
        sub_categorys: video.sub_categorys?.id,
        tags: video.tags?.map((tag) => tag.id) || [],
        channel: video.channel?.id,
        campaign: video.campaign?.id,
        published_date: video?.published_date,
      });
      setPreviewCover(video.cover || null);
      setTagsTouched(false);
    }
  }, [video]);

  const handleChange = (e) => {
    const { id, value, type, checked, files } = e.target;

    if (type === "checkbox" && id.startsWith("tag +")) {
      const tagId = parseInt(id.split(" + ")[1], 10);
      setFormData((prevData) => {
        // اولین باری که کاربر با تگ‌ها تعامل می‌کند، لیست قبلی (که از خود
        // ویدیو پیش‌بارگذاری شده بود) کنار گذاشته می‌شود تا فقط انتخاب
        // تازه‌ی او حساب شود، نه ترکیب پنهانِ قبلی‌ها + جدید.
        const baseTags = tagsTouched ? prevData.tags : [];
        return {
          ...prevData,
          tags: checked
            ? [...baseTags, tagId]
            : baseTags.filter((tag) => tag !== tagId),
        };
      });
      if (!tagsTouched) {
        setTagsTouched(true);
      }
    } else if (type === "file" && id === "videoFile") {
      setFormData((prevData) => ({
        ...prevData,
        videoFile: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    }
  };

  const handleCoverChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        cover: file,
      }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewCover(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading
    setError(null);

    try {
      const descriptionFormData = new FormData();
      descriptionFormData.append("title", formData.title);
      descriptionFormData.append("description", formData.description);
      descriptionFormData.append("cast", formData.cast);
      descriptionFormData.append("categorys", formData.categorys);
      descriptionFormData.append("sub_categorys", formData.sub_categorys);
      descriptionFormData.append("channel", formData.channel);
      descriptionFormData.append("campaign", formData.campaign);
      descriptionFormData.append("published_date", formData.published_date);
      formData.tags.forEach((tagId) => {
        descriptionFormData.append("tags", tagId);
      });

      const repostFormData = new FormData();
      repostFormData.append("description", formData.description);
      repostFormData.append("published_date", formData.published_date);

      // Update video file if exists
      if (formData.videoFile) {
        const videoFormData = new FormData();
        videoFormData.append("video", formData.videoFile);
        campaignId
          ? await videoFetcher.videoCanpaignEdit(videoFormData, id)
          : await videoFetcher.videoEdit(videoFormData, id);
        showToast("success", "ویدئو با موفقیت تغییر یافت.");
      }

      // Update description and other fields
      campaignId
        ? await videoFetcher.videoCampaignDescriptionEdit(
            descriptionFormData,
            id
          )
        : repost
        ? await videoFetcher.videoDescriptionEdit(repostFormData, id)
        : await videoFetcher.videoDescriptionEdit(descriptionFormData, id);
      showToast("success", "اطلاعات شما با موفقیت تغییر یافت.");

      // Update cover if it exists
      if (formData.cover) {
        const coverFormData = new FormData();
        coverFormData.append("cover", formData.cover);
        campaignId
          ? await videoFetcher.videoCampaignCoverEdit(coverFormData, id)
          : await videoFetcher.videoCoverEdit(coverFormData, id);
        showToast("success", "پوستر با موفقیت تغییر یافت.");
      }

      // campaignId
      //   ? history.push(
      //       `/campaign-videos/?campaign=true&admin=false&publisher=${user.user_id}`
      //     )
      //   : history.push("/account");
    } catch (err) {
      setError("متاسفانه خطایی رخ داده است.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (value) => {
    const formattedDate = value.toString().replace(/\//g, "-");
    setDate(formattedDate);
    setFormData((prevData) => ({
      ...prevData,
      published_date: formattedDate,
    }));
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper
                  heading={repost ? "ویرایش بازنشر" : "ویرایش ویدئو"}
                />
              </div>
            </Col>
          </Row>
          {error && <p className="text-danger">{error}</p>}{" "}
          {/* Display error message */}
          <Form onSubmit={handleSubmit}>
            <Form.Row>
              {!repost && (
                <Form.Group as={Col} controlId="title">
                  <Form.Label>عنوان</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </Form.Group>
              )}

              <Form.Group as={Col} controlId="description">
                <Form.Label>توضیحات</Form.Label>
                <Form.Control
                  as="textarea"
                  value={formData.description}
                  onChange={handleChange}
                  style={{ minHeight: "90px" }}
                />
              </Form.Group>
            </Form.Row>

            {!repost && (
              <Form.Row>
                <Form.Group as={Col} controlId="cover">
                  <Form.Label>پوستر</Form.Label>
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        overflow: "hidden",
                        marginLeft: "10px",
                      }}
                    >
                      {previewCover && (
                        <img
                          src={
                            previewCover.startsWith("data:")
                              ? previewCover
                              : baseURL + previewCover
                          }
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                    <Form.Control type="file" onChange={handleCoverChange} />
                  </div>
                </Form.Group>
              </Form.Row>
            )}

            {!repost && (
              <Form.Row>
                <Form.Group as={Col} controlId="cast">
                  <Form.Label>نویسندگان</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.cast}
                    onChange={handleChange}
                    style={{ maxHeight: "80px" }}
                  />
                </Form.Group>
              </Form.Row>
            )}

            {!repost && (
              <Form.Row>
                <Form.Group as={Col} controlId="videoFile">
                  <Form.Label>ویدئو</Form.Label>
                  <Form.Control type="file" onChange={handleChange} />
                </Form.Group>
              </Form.Row>
            )}

            {!repost && (
              <>
                <Row>
                  <Col lg={12} style={{ marginTop: "20px" }}>
                    <div className="main-title">
                      <h6 className="mb-1 mr-1">دسته بندی</h6>
                    </div>
                  </Col>
                </Row>

                <Row
                  className="category-checkbox"
                  style={{
                    padding: "0px 15px",
                    maxHeight: "500px",
                    overflow: "auto",
                  }}
                >
                  {categories?.map((item, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      custom
                      label={item?.name}
                      name="category"
                      id={`category + ${item?.id}`}
                      checked={formData.categorys === item?.id}
                      onChange={() =>
                        handleChange({
                          target: { id: "categorys", value: item.id },
                        })
                      }
                    />
                  ))}
                </Row>

                <Row>
                  <Col lg={12} style={{ marginTop: "20px" }}>
                    <div className="main-title">
                      <h6 className="mb-1 mr-1">زیردسته</h6>
                    </div>
                  </Col>
                </Row>

                <Row
                  className="sub_category-checkbox"
                  style={{
                    padding: "0px 15px",
                    maxHeight: "500px",
                    overflow: "auto",
                  }}
                >
                  {subCategories?.map((item, index) => (
                    <Form.Check
                      key={index}
                      type="radio"
                      custom
                      label={item?.name}
                      name="sub_category"
                      id={`sub_category + ${item?.id}`}
                      checked={formData.sub_categorys === item?.id}
                      onChange={() =>
                        handleChange({
                          target: { id: "sub_categorys", value: item.id },
                        })
                      }
                    />
                  ))}
                </Row>

                <Row>
                  <Col lg={12} style={{ marginTop: "20px" }}>
                    <div className="main-title">
                      <h6 className="mb-1 mr-1">برچسب</h6>
                    </div>
                  </Col>
                </Row>
                <Row
                  className="category-checkbox"
                  style={{
                    padding: "0px 15px",
                    maxHeight: "500px",
                    overflow: "auto",
                  }}
                >
                  {tags?.results?.map((item, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      custom
                      label={item?.name}
                      id={`tag + ${item?.id}`}
                      name="tag"
                      checked={formData.tags.includes(item?.id)}
                      onChange={(e) => handleChange(e)}
                    />
                  ))}
                </Row>
              </>
            )}

            <Row>
              <Col lg={4}>
                <Form.Group controlId="video-casting">
                  <Form.Label
                    style={{
                      marginLeft: "10px",
                      marginTop: "20px",
                      marginRight: "6px",
                    }}
                  >
                    تاریخ انتشار
                  </Form.Label>
                  <DatePicker
                    value={formData.published_date}
                    onChange={handleDateChange}
                    format="YYYY/MM/DD HH:mm:ss"
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col className="text-right">
                <Button
                  variant="success mr-1 mt-2 mb-4"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      در حال ذخیره‌سازی...
                    </>
                  ) : (
                    "ذخیره تغییرات"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default ChannelEdit;
